module.exports = __webpack_public_path__ + "img/headset.fae412cd.svg";